import { useStreamSettingsStore } from '../../../../stores/stream-screen-settings.store';
import { StreamMode } from '../../../../types';
import { SelectionMenuDefault } from './SelectionMenuDefault';
import { SelectionMenuEditor } from './SelectionMenuEditor';

export function SelectionMenu() {
  const mode = useStreamSettingsStore((state) => state.mode);

  if (mode === StreamMode.EDITOR) {
    return <SelectionMenuEditor />;
  }

  return <SelectionMenuDefault />;
}
